export const userAlertsRoute = 'user-alerts';
export const calendarRoute = 'calendar';
export const createAlertRoute = 'create';

